export default __webpack_public_path__ + "static/media/pos-kot.ed76f496.jpg";